import {
    FETCH_ADAPTIVE_COACHING_PLAN_FETCHING,
    FETCH_ADAPTIVE_COACHING_PLAN_SUCCESS,
    FETCH_ADAPTIVE_COACHING_PLAN_FAIL,
    FETCH_ADAPTIVE_COACHING_EVENTS_FETCHING,
    FETCH_ADAPTIVE_COACHING_EVENTS_SUCCESS,
    FETCH_ADAPTIVE_COACHING_EVENTS_FAIL,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_UPDATING,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_SUCCESS,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_FAIL,
    SET_TRAINING_PLAN_STATUS
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    adaptiveCoachPlan: {
        plan: {},
        isFetching: false,
        fetchFailed: false,
        fetchSuccess: false,
        trainingStatus: {
            trainingStatusUpdating: false,
            trainingStatusUpdated: false
        },
        trainingPlanStatus: null
    },
    adaptiveCoachPlanEvents: {
        events: [],
        isFetching: false,
        fetchFailed: false,
        fetchSuccess: false
    }
};

const fetchAdaptiveCoachPlanFetching = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlan: {
            ...state.adaptiveCoachPlan,
            plan: {},
            isFetching: true,
            fetchFailed: false,
            fetchSuccess: false
        }
    };
};

const fetchAdaptiveCoachPlanSuccess = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlan: {
            ...state.adaptiveCoachPlan,
            plan: action.adaptiveCoachPlan,
            isFetching: false,
            fetchFailed: false,
            fetchSuccess: true
        }
    };
};

const fetchAdaptiveCoachPlanError = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlan: {
            ...state.adaptiveCoachPlan,
            plan: {},
            isFetching: false,
            fetchFailed: true,
            fetchSuccess: false
        }
    };
};

const fetchAdaptiveCoachPlanEventsFetching = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlanEvents: {
            ...state.adaptiveCoachPlanEvents,
            events: [],
            isFetching: true,
            fetchFailed: false,
            fetchSuccess: false
        }
    };
};

const fetchAdaptiveCoachPlanEventsSuccess = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlanEvents: {
            ...state.adaptiveCoachPlanEvents,
            events: action.adaptiveCoachPlanEvents,
            isFetching: false,
            fetchFailed: false,
            fetchSuccess: true
        }
    };
};

const fetchAdaptiveCoachPlanEventsError = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlanEvents: {
            ...state.adaptiveCoachPlanEvents,
            events: [],
            isFetching: false,
            fetchFailed: true,
            fetchSuccess: false
        }
    };
};

const updateAdaptiveCoachTrainingVersionUpdating = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlan: {
            ...state.adaptiveCoachPlan,
            trainingVersion: {
                versionUpdating: true,
                versionUpdated: false
            }
        }
    };
};

const updateAdaptiveCoachTrainingVersionFinished = (success) => (state, action) => {
    return {
        ...state,
        adaptiveCoachPlan: {
            ...state.adaptiveCoachPlan,
            trainingVersion: {
                versionUpdating: false,
                versionUpdated: success
            }
        }
    };
};

const setAdaptiveCoachPlanStatus = (state, action) => {
    return {
        ...state,
        adaptiveCoachPlan: {
            ...state.adaptiveCoachPlan,
            trainingPlanStatus: action.status
        }
    };
};

const handlers = {
    [FETCH_ADAPTIVE_COACHING_PLAN_FETCHING]: fetchAdaptiveCoachPlanFetching,
    [FETCH_ADAPTIVE_COACHING_PLAN_SUCCESS]: fetchAdaptiveCoachPlanSuccess,
    [FETCH_ADAPTIVE_COACHING_PLAN_FAIL]: fetchAdaptiveCoachPlanError,
    [FETCH_ADAPTIVE_COACHING_EVENTS_FETCHING]: fetchAdaptiveCoachPlanEventsFetching,
    [FETCH_ADAPTIVE_COACHING_EVENTS_SUCCESS]: fetchAdaptiveCoachPlanEventsSuccess,
    [FETCH_ADAPTIVE_COACHING_EVENTS_FAIL]: fetchAdaptiveCoachPlanEventsError,
    [UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_UPDATING]: updateAdaptiveCoachTrainingVersionUpdating,
    [UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_SUCCESS]: updateAdaptiveCoachTrainingVersionFinished(true),
    [UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_FAIL]: updateAdaptiveCoachTrainingVersionFinished(false),
    [SET_TRAINING_PLAN_STATUS]: setAdaptiveCoachPlanStatus
};

export default function fbtAdaptiveCoachingTrainingPlan(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

/** Fetching Adaptive Coach Plan / DSW */
export const isAdaptiveCoachPlanFetching = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.isFetching
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.isFetching
        : false;
};

export const isAdaptiveCoachPlanFail = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.fetchFailed
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.fetchFailed
        : false;
};

export const isAdaptiveCoachPlanSuccess = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.fetchSuccess
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.fetchSuccess
        : false;
};

export const getAdaptiveCoachPlan = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.plan || {};
};

export const getAdaptiveCoachTrainingStatus = (state) =>
    state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.trainingStatus || {};

/** Fetching Adaptive Coach Plan Events / DSW */
export const isAdaptiveCoachPlanEventsFetching = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.isFetching
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.isFetching
        : false;
};

export const isAdaptiveCoachPlanEventsFail = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.fetchFailed
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.fetchFailed
        : false;
};

export const isAdaptiveCoachPlanEventsSuccess = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.fetchSuccess
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.fetchSuccess
        : false;
};

export const getAdaptiveCoachPlanEvents = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlanEvents.events || [];
};

export const isAdaptiveCoachPlanTrainingVersionUpdating = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.trainingVersion.versionUpdating
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.trainingVersion.versionUpdating
        : false;
};

export const isAdaptiveCoachPlanTrainingVersionUpdated = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.trainingVersion.versionUpdated
        ? state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.trainingVersion.versionUpdated
        : false;
};

export const getAdaptiveCoachPlanTrainingStatus = (state) => {
    return state.fbtAdaptiveCoachingTrainingPlan.adaptiveCoachPlan.trainingPlanStatus;
};
